module.exports = __webpack_public_path__ + "img/MS.624da722.svg";